import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { legacyApi, type EstimateDetail } from '../../../services/legacyApi';
import { QuickQuotationEditor } from './QuickQuotationEditor';
import { LegacyEstimateDetailEnhanced as LegacyEstimateDetailClassic } from './LegacyEstimateDetailEnhanced';

export const LegacyEstimateDetail: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const location = useLocation();
    const navigate = useNavigate();
    const [estimate, setEstimate] = useState<EstimateDetail | null>(null);
    const [loading, setLoading] = useState(true);
    const query = useMemo(() => new URLSearchParams(location.search), [location.search]);
    const queryView = query.get('view');
    const forceClassic = query.get('forceClassic') === '1';

    useEffect(() => {
        let cancelled = false;
        const run = async () => {
            if (!id) {
                setLoading(false);
                return;
            }
            try {
                const detail = await legacyApi.estimates.getDetail(Number(id));
                if (!cancelled) setEstimate(detail);
            } catch (error) {
                console.error(error);
            } finally {
                if (!cancelled) setLoading(false);
            }
        };
        void run();
        return () => {
            cancelled = true;
        };
    }, [id]);

    useEffect(() => {
        if (queryView && queryView !== 'classic' && !estimate) {
            const params = new URLSearchParams(location.search);
            params.set('view', 'classic');
            navigate(
                {
                    pathname: location.pathname,
                    search: params.toString() ? `?${params.toString()}` : '',
                },
                { replace: true },
            );
        }
    }, [estimate, location.pathname, location.search, navigate, queryView]);

    if (loading) {
        return <div className="p-8 text-center text-muted-foreground">Loading estimate...</div>;
    }

    if (estimate && estimate.entry_mode === 'quick_quote' && !forceClassic) {
        return <QuickQuotationEditor estimateId={estimate.estimate_id} initialEstimate={estimate} />;
    }

    localStorage.setItem('estimateViewMode', 'classic');
    return <LegacyEstimateDetailClassic />;
};

